import React from 'react';

export type ResourceContextInfo = {
  name: string;
  essential: boolean;
  pending?: boolean;
  failed?: boolean;
  succeeded?: boolean;
  completed?: boolean;
  status?: number;
};

export interface ResourcesContextProps {
  registerResource: (resource: ResourceContextInfo) => void;
  onResourceComplete: (resource: ResourceContextInfo) => void;
  onResourceSuccess: (resource: ResourceContextInfo, status: number) => void;
  onResourceFailure: (resource: ResourceContextInfo, status: number) => void;
  errorsHandled?: boolean;
}

const ResourcesContext = React.createContext<ResourcesContextProps>(null);

export default ResourcesContext;
